module.exports = __webpack_public_path__ + "img/circle.17e74075.png";